export const GET_CHAT_CONNECTIONS = "GET_CHAT_CONNECTIONS";
export const SET_AS_READ = "SET_AS_READ";
export const GET_CHAT_MESSAGES = "GET_CHAT_MESSAGES";
export const POST_MESSAGE = "POST_MESSAGE";
export const POST_SEARCH_CONNECTION = "POST_SEARCH_CONNECTION";
export const POST_SEARCH_CONSULTANTS = "POST_SEARCH_CONSULTANTS";
export const MESSAGE_CONVERSATION = "MESSAGE_CONVERSATION";
export const MESSAGE_GET_CHAT = "MESSAGE_GET_CHAT";
export const MESSAGE_SEND_SMS = "MESSAGE_SEND_SMS";
export const MESSAGE_SEARCH_CONVERSATION = "MESSAGE_SEARCH_CONVERSATION";
export const MESSAGE_SEARCH_SMS = "MESSAGE_SEARCH_SMS";
export const MESSAGE_SEARCH_CONTACT = "MESSAGE_SEARCH_CONTACT";



